<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Fitter was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Fitter - {{ this.fitter.firstName }} {{ this.fitter.lastName }}</h1>
    <app-audit-line [data]='this.fitter'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-fitter-form [fitter]='this.fitter'></app-fitter-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/fitters'>Cancel</button>
    </form>
  </div>
</div>
